// Override Settings
var boostPFSInstantSearchConfig = {
  search: {

  }
};

(function () {
  BoostPFS.inject(this);

  // Einordnung des Produkts für die Unterzeile (Produkttyp).
  // WICHTIG: gleiche Regeln wie im Theme-Snippet snippets/vch-product-label.liquid
  // und im Boost-Karten-Script (classify). Wenn hier etwas geändert wird, dort ebenfalls anpassen.
  function vchProductLabel(data) {
    var tags = data.tags || [];
    var type = data.product_type || '';
    var title = data.title || '';
    var hasTag = function (t) { return tags.indexOf(t) !== -1; };

    var isSchiene = hasTag('Vorhangschiene');
    var isStange = hasTag('Vorhangstange');
    var isSystem = isSchiene || isStange;
    var isPlissee = !isSystem && (hasTag('Plissee') || /^(Waben)?plissee/i.test(title));
    var isRollo = !isSystem && !isPlissee && /Rollo/i.test(type);
    var isZubehoer = !isSystem && !isPlissee && !isRollo && (hasTag('Zubehör') || type === 'Vorhang Zubehör');

    var hasWidth = tags.some(function (t) { return t.indexOf('width:') === 0; });
    var hasFertigTag = tags.some(function (t) { return t.indexOf('Fertigvorhang') === 0 || t.indexOf('mit Faltenband') !== -1; });

    // Schienen/Stangen haben ebenfalls Lieferzeit-Tags wie "2 - 5 Wochen",
    // deshalb werden sie (und Plissees/Zubehör) vorher ausgeschlossen.
    var isMass = !isSystem && !isPlissee && !isRollo && !isZubehoer && !hasFertigTag && (
      type === 'Stoff' ||
      tags.some(function (t) { return t.indexOf('Massvorhang') === 0 || /^\d+ - \d+ Wochen$/.test(t); })
    );
    var isFertig = !isSystem && !isPlissee && !isRollo && !isZubehoer && !isMass && (hasFertigTag || hasWidth);

    var typeLabels = { 'Rollo / Plissée': 'Rollo' };
    if (isSchiene) return 'Vorhangschiene nach Mass';
    if (isStange) return 'Vorhangstange nach Mass';
    if (isPlissee) return 'Plissee nach Mass';
    if (isRollo) return 'Rollo';
    if (isZubehoer) return 'Zubehör';
    if (isMass) return 'Vorhang nach Mass';
    if (isFertig) return 'Fertigvorhang';
    return typeLabels[type] || type;
  }

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function (suggestionElement, searchElement, searchBoxId) {
    if (!suggestionElement) suggestionElement = this.$uiMenuElement;
    if (!searchElement) searchElement = this.$element;
    if (!searchBoxId) searchBoxId = this.id;
  };

  BoostPFS.prototype.beforeBuildSearchBox = function (id) {
    // Remove theme's instant search events
    var cloneSearchBar = jQ(id).clone();
    jQ(id).replaceWith(cloneSearchBar);

    if (Utils.InstantSearch.isFullWidthMobile()) {
      jQ(id).removeAttr('autofocus');
      if (jQ(id).is(':focus')) {
        jQ(id).blur();
      }
    }
  };

  BoostPFS.prototype.afterCloseSuggestionMobile = function (searchBoxId, isCloseSearchBox) {
    // Close theme's search pop up
    if (isCloseSearchBox) {
      jQ('.mobile-search').hide();
      jQ('body').attr('style', '')
    }
  };

  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);
    var self = this;
    
    jQ('.header__link.action-area__link').off('click').click(function(e) {
      e.preventDefault();
      jQ('.search__fields input').focus();
      self.openSuggestionStyle3();
      jQ('.js-search-popup').addClass('boost-hidden');
    });
  }

  InstantSearchResultItemProduct.prototype.getTemplate = function (tempType) {
		switch (tempType) {
			case InstantSearchResultItemProduct.tempType.IMAGE:
				return `
					<div class="{{class.searchSuggestion}}-left">
						<img tabindex="-1" src="{{imageUrl}}" alt="{{escapedTitle}}">
					</div>
				`.trim();
			case InstantSearchResultItemProduct.tempType.SKU:
				return `
					<p class="{{class.searchSuggestion}}-product-sku">SKU: {{sku}}</p>
				`.trim();
			case InstantSearchResultItemProduct.tempType.VENDOR:
				return `
					<p class="{{class.searchSuggestion}}-product-vendor">{{vendor}}</p>
				`.trim();
			case InstantSearchResultItemProduct.tempType.PRICE:
				return `
					<p class="{{class.searchSuggestion}}-product-price">
						<span class="{{class.searchSuggestion}}-product-regular-price">{{regularPrice}}</span>
					</p>
				`.trim();
			case InstantSearchResultItemProduct.tempType.PRICE_SALE:
				return `
					<p class="{{class.searchSuggestion}}-product-price">
            <span class="{{class.searchSuggestion}}-product-sale-price">{{regularPrice}}</span>&nbsp;
						<s>{{compareAtPrice}}</s>
						
					</p>
				`.trim();
			default:
				return `
					<li class="{{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}" role="option">
						<a tabindex="-1" href="{{url}}" {{newTabAttribute}}>
							{{itemProductImage}}
							<div class="{{class.searchSuggestion}}-right">
								<p class="{{class.searchSuggestion}}-product-title">{{title}}</p>
								{{itemProductSku}}
								{{itemProductVendor}}
                                {{itemProductType}}
								{{itemProductPrice}}
							</div>
						</a>
					</li>
				`.trim();
		}
	}
  
  
  InstantSearchResultItemProduct.prototype.compileTemplate = function() {
		if (this.isShow) {
			var searchTerm = Utils.stripHtml(Globals.currentTerm);
			// Product image
			var imageHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
				imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
				imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
			}
			// Product title
			var productTitle = this.customizeProductTitle();

			// Get color from tags (farbnuance:value)
			var colorValue = '';
			if (this.data.tags && this.data.tags.length > 0) {
				for (var i = 0; i < this.data.tags.length; i++) {
					if (this.data.tags[i].indexOf('farbnuance:') === 0) {
						colorValue = this.data.tags[i].split(':')[1];
						// Capitalize first letter
						if (colorValue) {
							colorValue = colorValue.charAt(0).toUpperCase() + colorValue.slice(1);
						}
						break;
					}
				}
			}
			if (colorValue) {
				productTitle = productTitle + ' - ' + colorValue;
			}

			productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
			// SKU
			var skuHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
				skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
				skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
			}
			// Vendor
			var vendorHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
				vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
				vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
			}
			// Price
			var priceHTML = this.compileSuggestionProductPrice();
			// Open the result item in new tab when selected
			var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';
			// Product type (gleiche Regeln wie Produktseite und Boost-Karten)
			var productType = vchProductLabel(this.data);
			// "ab" vor den Preis bei allem, was nach Mass konfiguriert wird (wie in den Kacheln)
			var AB_LABELS = ['Vorhang nach Mass', 'Plissee nach Mass', 'Vorhangschiene nach Mass', 'Vorhangstange nach Mass'];
			if (AB_LABELS.indexOf(productType) !== -1) {
				priceHTML = priceHTML.replace(/(-product-(?:regular|sale)-price">)/, '$1ab ');
			}
			return this.getTemplate()
				.replace(/{{id}}/g, this.id)
				.replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
				.replace(/{{url}}/g, this.url)
				.replace(/{{newTabAttribute}}/g, newTabAttr)
				.replace(/{{itemProductImage}}/g, imageHTML)
				.replace(/{{title}}/g, productTitle)
				.replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
				.replace(/{{itemProductSku}}/g, skuHTML)
				.replace(/{{itemProductVendor}}/g, vendorHTML)
				.replace(/{{itemProductPrice}}/, priceHTML)
				.replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
				.replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
				.replace(/{{itemProductType}}/g, productType)
                .replace(/{{itemProductVendor}}/g, vendorHTML);
		} else {
			return '';
		}
	}
})();